export const ASSET_PROTECT = 'Asset Protect';
export const NONE = 'None';

export const InsuranceTypes = [
  ASSET_PROTECT,
  // 'Resident Liability',
  NONE,
];
